import { withTranslation } from "react-i18next";
import { useContext, useState, useEffect, useCallback, useMemo } from "react";
import { currentYear, DataViewCategoryType, startYear } from "../../core/constants/common";
import { RegulationContext } from "../../App";
import { BiPlus } from "react-icons/bi";

const DashboardFilter = ({ t, type, existingFilter, onFilterHide, onApplyFilter, onOpenWidgetLib }) => {

	const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
	const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";

	const year = new Date().getFullYear();

	const [filter, setFilter] = useState({
		period: existingFilter?.period ?? `${year}-01-01`,
		category: 'Environmental',
		annualyear: new Date().getFullYear(),
		selectedTopic: null,
		categoryType: null,
		topicsFromFilter: null,
		selectedTopicIds: [],
	});

	const applyFilter = useCallback(() => {
		onApplyFilter(filter);
		onFilterHide(false);
	}, [filter, onApplyFilter, onFilterHide]);

	useEffect(() => {
		if (!glbRegulationId) return;

		applyFilter();
	}, [glbRegulationId, applyFilter]);

	const yearOptions = useMemo(() => {
		const options = [];
		for (let i = currentYear; i >= startYear; i--) {
			options.push(<option value={i} key={i}>{i}</option>);
		}
		return options;
	}, []);

	const handleCategoryChange = (val) => {
		const updatedFilter = { ...filter, category: val };
		setFilter(updatedFilter);
	}

	const renderDashboardFilters = () => {
		return (
			<>
				<div>
					{/* <label className="mb-1">{t('Category.label')}</label> */}
					<select className="form-select " value={filter.category} onChange={(e) => handleCategoryChange(e.target.value)}>
						<option value="Environmental" key="Environmental">{t("Environmental.label")}</option>
						<option value="Social" key="Social">{t("Social.label")}</option>
						<option value="Governance" key="Governance">{t("Governance.label")}</option>
					</select>
				</div>

				<div>
					{/* <label className="mb-1">{t('Year.label')}</label> */}
					<select className="form-select " value={filter.annualyear} onChange={(e) => { setFilter({ ...filter, annualyear: e.target.value }); }}>
						{yearOptions}
					</select>
				</div>
				<div>
					<button
						type="button"
						className="btn btn-primary"
						onClick={() => onOpenWidgetLib()}>
						<BiPlus /> {t("AddWidgets.label")}
					</button>
				</div>
			</>
		)
	}

	return (
		<>
			{
				<div className="dashboard_filter_section_row m-0">
					{renderDashboardFilters()}
				</div>
			}
		</>
	);

};

export default withTranslation()(DashboardFilter);